export default __webpack_public_path__ + "static/soundtrack-polar-headphones-ad395cfd931de68b5a8dab06daaf9a9e.gif";